// Flip this back to true to restore the reusable email registration forms.
export const SHOW_CUSTOMER_SIGNUP_FORM = false;

// Keep the founders artwork available while hiding it for the launch layout.
export const SHOW_FOOTER_FOUNDERS_IMAGE = false;

// Public store links used by the hero and footer badges.
export const APP_STORE_URL =
  "https://apps.apple.com/il/app/nightly-tailored-nightlife/id6602895303";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.nightly.appclient";

export const NIGHTLY_APP_SCHEME = "nightlyappclient";
